// extracted by mini-css-extract-plugin
export default {"iframeContent":"iq6yXa0nNYjtBDStaFmw"};